<template>
  <div class="content">
    <div
      v-if="content.title"
      class="header">
      <span class="title">{{ content.title }}</span>
      <span class="people">{{ content.people }}</span>
    </div>
    <p
      class="text">
      <span
        v-if="content.subtitle"
        class="subtitle">{{ content.subtitle }}<br></span>
      <span v-html="content.text" />
    </p>
  </div>
</template>
<script>
export default {
  props: {
    content: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
  .content {
    width: 80%;
    position: absolute;
    bottom: 70%;
    left: 10%;
  }

  .header {
    display: flex;
    flex-flow: row wrap;
  }

  .title {
    margin-right: 15px;
    margin-bottom: 10px;
    font-size: 24px;
    font-weight: bold;
  }

  .subtitle {
    font-weight: bold;
  }

  .people {
    margin-bottom: 10px;
    border-radius: 25px;
    padding: 1px 15px 2px;
    font-weight: bold;
    background-color: $nos-op3-dark-blue;
    color: #FFF;
  }

  .text {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/scrollimage/ScrollImageContent.vue